import { render, staticRenderFns } from "./AlipayPayConfig.vue?vue&type=template&id=78199d34&scoped=true"
import script from "./AlipayPayConfig.vue?vue&type=script&lang=js"
export * from "./AlipayPayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78199d34",
  null
  
)

export default component.exports